import { BundleRoute, BundleRouteStep } from '../../types/bundleTypes';
import { invertColor } from '../oldPlanner/utils/bundleDraft';

export function formatEta(step: BundleRouteStep): string {
  return step.eta ? step.eta.substr(0, 5) : '';
}

export function formatWindow(step: BundleRouteStep): string {
  return `${step.windowStart.substr(0, 5)} - ${step.windowEnd.substr(0, 5)}`;
}

export function formatTimePerStop(route: BundleRoute | number): string {
  const timePerStopSeconds =
    typeof route === 'number' ? route : route.timePerStopSeconds;
  const minutes = Math.floor(timePerStopSeconds / 60);
  const seconds = Math.ceil(timePerStopSeconds) % 60;
  return timePerStopSeconds <= 0
    ? '-'
    : `${minutes}:${`00${seconds}`.slice(-2)}`;
}

function hexToRgb(hex) {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(
        result[3],
        16
      )},1)`
    : null;
}

const MAX_CONTRAST_COLORS_EXT = [
  '#2f4f4f',
  '#556b2f',
  '#8b4513',
  '#6b8e23',
  '#2e8b57',
  '#191970',
  '#006400',
  '#708090',
  '#8b0000',
  '#bc8f8f',
  '#b8860b',
  '#008b8b',
  '#4682b4',
  '#000080',
  '#d2691e',
  '#9acd32',
  '#32cd32',
  '#8fbc8f',
  '#8b008b',
  '#d2b48c',
  '#48d1cc',
  '#9932cc',
  '#ff4500',
  '#ffa500',
  '#ffd700',
  '#6a5acd',
  '#ffff00',
  '#0000cd',
  '#00ff00',
  '#00ff7f',
  '#dc143c',
  '#00bfff',
  '#f4a460',
  '#0000ff',
  '#a020f0',
  '#adff2f',
  '#ff6347',
  '#ff00ff',
  '#1e90ff',
  '#db7093',
  '#f0e68c',
  '#fa8072',
  '#dda0dd',
  '#87ceeb',
  '#ff1493',
  '#ee82ee',
  '#98fb98',
  '#7fffd4',
  '#ff69b4',
];

const MAX_CONTRAST_COLORS_EXT_RGBA = MAX_CONTRAST_COLORS_EXT.map(color =>
  hexToRgb(color)
);

const MAX_CONTRAST_COLORS_INVERTED = MAX_CONTRAST_COLORS_EXT.map(color =>
  invertColor(color, true)
);

export function getRouteColor(bundleDraftId: string): string {
  const id = Number(bundleDraftId);
  const idx = Number.isNaN(id) ? 0 : id % MAX_CONTRAST_COLORS_EXT_RGBA.length;
  return MAX_CONTRAST_COLORS_EXT_RGBA[idx];
}

export function getRouteFontColor(bundleDraftId: string): string {
  const id = Number(bundleDraftId);
  const idx: number = Number.isNaN(id)
    ? 0
    : id % MAX_CONTRAST_COLORS_INVERTED.length;
  return MAX_CONTRAST_COLORS_INVERTED[idx];
}
